import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/opposing-pitchers/actions';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

class PitchersQuantity extends Component {
    onChange(value) {
        const {boundaryName} = this.props;
        this.props.dispatch(Action.set('OpposingPitchersAllowedQuantity', boundaryName, value));
    }

    getOptions() {
        const minVal = 0;
        const maxVal = 4;
        let options = {};

        for (let i = minVal; i <= maxVal; i++) {
            options[i] = i;
        }

        return options;
    }

    render() {
        const {opposingPitchers, boundaryName} = this.props;
        const value = opposingPitchers.getPitchersQuantity(boundaryName);

        return (
            <SimpleSelect
                key={`pitchersQuantity-${boundaryName}-${value}`}
                className="input-sm"
                value={value}
                options={this.getOptions()}
                onChange={::this.onChange}
            />
        );
    }
}

function mapStatesToProps(state) {
    return {
        opposingPitchers: state.opposingPitchers,
    };
}

export default connect(mapStatesToProps)(PitchersQuantity);
